module.exports = __webpack_public_path__ + "static/media/concert10.6ebc8725.jpg";